import dayjs, { Dayjs, isDayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// This second import is required to make the Dayjs type extensions available
import 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/plugin/isBetween';
import isToday from 'dayjs/plugin/isToday';
import 'dayjs/plugin/isToday';
import isoWeek from 'dayjs/plugin/isoWeek';
import 'dayjs/plugin/isoWeek';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import 'dayjs/plugin/weekday';
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isoWeek);
dayjs.extend(isToday);
dayjs.extend(localeData);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(weekday);
export { dayjs, Dayjs, isDayjs };
//# sourceMappingURL=dayjs.js.map